(function(angular) {
    'use strict';

    /**
     * @ngdoc controller
     * @name psonocli.controller:ModalDatastoreNewEntryCtrl
     * @requires $scope
     * @requires $uibModalInstance
     * @requires $translate
     * @requires psonocli.itemBlueprint
     * @requires psonocli.cryptoLibrary
     * @requires psonocli.helper
     *
     * @description
     * Controller for the "New Entry" modal
     */
    angular.module('psonocli').controller('ModalDatastoreNewEntryCtrl', ['$scope', '$uibModalInstance', '$translate', 'itemBlueprint', 'cryptoLibrary', 'helper', 'parent', 'path',
        function ($scope, $uibModalInstance, $translate, itemBlueprint, cryptoLibrary, helper, parent, path) {

            $scope.reset = reset;
            $scope.on_select = on_select;
            $scope.save = save;
            $scope.cancel = cancel;
            $scope.toggle_input_type = toggle_input_type;

            $scope.parent = parent;
            $scope.path = path;
            $scope.state = {
                open_requests: 0,
                closed_request: 0,
                percentage_complete: 0,
                next_step: '',
                processing: false
            };
            $scope.name = '';
            $scope.content = '';
            $scope.data = {
                'callback_url': '',
                'callback_user': '',
                'callback_pass': ''
            };
            $scope.isCollapsed = true;
            $scope.errors = [];

            $scope.bp = {
                all: itemBlueprint.get_blueprints(),
                selected: itemBlueprint.get_default_blueprint()
            };
            var _translations;

            activate();

            function activate(){
                reset_fields();

                $scope.$watch('bp.selected', function(newValue, oldValue) {
                    if (typeof $scope.bp.selected.onNewModalOpen !== 'undefined') {
                        $scope.bp.selected.onNewModalOpen($scope.bp.selected);
                    }
                });

                itemBlueprint.register('upload_started', function(max){
                    $scope.state.processing = true;
                    $scope.state.open_requests = max;
                });

                itemBlueprint.register('upload_step_complete', function(next_step){
                    $scope.state.closed_request = $scope.state.closed_request + 1;
                    $scope.state.percentage_complete = Math.round($scope.state.closed_request / $scope.state.open_requests * 1000) / 10;
                    $scope.state.next_step = next_step;
                });

                itemBlueprint.register('upload_complete', reset);
                $translate([
                    'INVALID_TOTP_SECRET',
                    'INVALID_URL'
                ]).then(function (translations) {
                    _translations = translations;
                });
            }

            /**
             * @ngdoc
             * @name psonocli.controller:ModalDatastoreNewEntryCtrl#reset_fields
             * @methodOf psonocli.controller:ModalDatastoreNewEntryCtrl
             *
             * @description
             * Resets fields to default values
             */
            function reset_fields() {
                for (var i = 0; i < $scope.bp.selected.fields.length; i++) {
                    if (!$scope.bp.selected.fields[i].hasOwnProperty('value')) {
                        continue
                    }
                    delete $scope.bp.selected.fields[i]['value'];
                }
            }

            /**
             * @ngdoc
             * @name psonocli.controller:ModalDatastoreNewEntryCtrl#reset
             * @methodOf psonocli.controller:ModalDatastoreNewEntryCtrl
             *
             * @description
             * Triggered once someone clicks the cancel button in the modal
             */
            function reset() {
                $scope.submitted = false;
                $scope.state.open_requests = 0;
                $scope.state.closed_request = 0;
                $scope.state.percentage_complete = 0;
                $scope.state.next_step ='';
                $scope.state.processing = false;
            }

            /**
             * @ngdoc
             * @name psonocli.controller:ModalDatastoreNewEntryCtrl#on_select
             * @methodOf psonocli.controller:ModalDatastoreNewEntryCtrl
             *
             * @description
             * Triggered once someone selects another entry
             */
            function on_select() {
                reset();
                reset_fields();
                if ($scope.bp.selected.hasOwnProperty('activate')) {
                    $scope.bp.selected.activate($scope.bp.selected);
                }
            }


            /**
             * @ngdoc
             * @name psonocli.controller:ModalDatastoreNewEntryCtrl#save
             * @methodOf psonocli.controller:ModalDatastoreNewEntryCtrl
             *
             * @description
             * Triggered once someone clicks the save button in the modal
             */
            function save() {
                $scope.errors = [];
                $scope.credit_buy_address = itemBlueprint.server_credit_buy_address();

                for (var i = 0; i < $scope.bp.selected.fields.length; i++) {
                    var field = $scope.bp.selected.fields[i];
                    if (field.hasOwnProperty("required")) {
                        if (field['required'] && field['value'] !== false && !field['value']) {
                            $scope.errors.push(field['title'] + '_IS_REQUIRED');
                            continue;
                        }
                    }
                    if (field.hasOwnProperty("validationType")) {
                        if (field['validationType'].toLowerCase() === 'url' && field['value'] && !helper.is_valid_url(field['value'])) {
                            $scope.errors.push(_translations.INVALID_URL);
                        }
                        if (field['validationType'].toLowerCase() === 'email' && field['value'] && !helper.is_valid_email(field['value'])) {
                            $scope.errors.push(_translations.INVALID_URL);
                        }
                        if (field['validationType'].toLowerCase() === 'totp_code' && field['value'] && !helper.is_valid_totp_code(field['value'])) {
                            $scope.errors.push(_translations.INVALID_TOTP_SECRET);
                        }
                    }

                }

                if ($scope.errors.length > 0) {
                    return;
                }

                $scope.bp.selected['link_id'] = cryptoLibrary.generate_uuid();
                $scope.bp.selected['callback_data'] = $scope.data;

                if ($scope.bp.selected.hasOwnProperty('preCreate')) {
                    var onSuccess = function(){
                        reset();
                        $uibModalInstance.close($scope.bp.selected);
                    };

                    var onError = function(errors) {

                        for (var i = 0; i < errors.length; i++) {
                            $scope.errors.push(errors[i]);
                            reset();
                        }
                    };
                    $scope.bp.selected.preCreate($scope.bp.selected, parent, path)
                        .then(onSuccess, onError);
                } else {
                    $uibModalInstance.close($scope.bp.selected);
                }
            }

            /**
             * @ngdoc
             * @name psonocli.controller:ModalDatastoreNewEntryCtrl#cancel
             * @methodOf psonocli.controller:ModalDatastoreNewEntryCtrl
             *
             * @description
             * Triggered once someone clicks the cancel button in the modal
             */
            function cancel() {
                $uibModalInstance.dismiss('cancel');
            }

            /**
             * @ngdoc
             * @name psonocli.controller:ModalDatastoreNewEntryCtrl#toggle_input_type
             * @methodOf psonocli.controller:ModalDatastoreNewEntryCtrl
             *
             * @description
             * toggles the type of an input
             *
             * @param id
             */
            function toggle_input_type(id) {
                if (document.getElementById(id).type === 'text') {
                    document.getElementById(id).type = 'password';
                } else {
                    document.getElementById(id).type = 'text';
                }
            }
        }]);

}(angular));